import { map } from 'rxjs/operators';

export default function pluck(keyOrPath, notSetValue) {
  return function pluck(source) {
    return Array.isArray(keyOrPath) ? source.pipe(map(function (x) {
      return x.getIn(keyOrPath, notSetValue);
    })) : source.pipe(map(function (x) {
      return x.get(keyOrPath, notSetValue);
    }));
  };
}